import React from 'react';
import { Loader as MantineLoader, Text } from '@mantine/core';
import { usePageTimeout } from '../../hooks/usePageTimeout';

interface LoaderProps {
    isPageLoader?: boolean;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    timeoutMs?: number;
}

function Loader({
    isPageLoader = false,
    size = 'md',
    timeoutMs = 30000,
}: LoaderProps) {
    const { showTimeoutWarning } = usePageTimeout({
        isEnabled: isPageLoader,
        timeoutMs,
    });

    return (
        <div
            className={`flex flex-col ${
                isPageLoader
                    ? 'w-screen h-[calc(100vh-10rem)]'
                    : 'h-full w-full'
            } justify-center items-center gap-4`}
        >
            <MantineLoader size={size} />
            {showTimeoutWarning && isPageLoader && (
                <Text size="sm" color="dimmed" className="text-center max-w-md">
                    Loading is taking longer than expected. The page will
                    refresh automatically in a few seconds to resolve any
                    session issues.
                </Text>
            )}
        </div>
    );
}

export default Loader;
